import { Component } from 'react';

import type { MiniEventTracker } from '@shared/types/frontend/mini-event-tracker';

import STYLES from './VideoItemNode.module.scss';

import { buildAdditionalInfoHotelMediaGalleryClicked } from '@hotels-hotel-detail/utils/mini-events/hotels-action';
import PlayOverlay from '@shared/ui/common/PlayOverlay';
import { withMiniEventTracker } from '@shared/ui/contexts/mini-events';
import {
  ACTION_TYPE,
  HOTEL_MEDIA_TYPE,
} from '@shared/utils-frontend/mini-events/constants';

type Props = {
  src: string;
  poster: string;
  miniEventTracker: MiniEventTracker;
};

type State = {
  videoPlaying: boolean;
};

class VideoItemNode extends Component<Props, State> {
  state: State = {
    videoPlaying: false,
  };

  vidRef: any;

  onClick = (control = '') => {
    if (control === 'play') {
      this.props.miniEventTracker.trackHotelsAction(
        ACTION_TYPE.HOTEL_MEDIA_GALLERY_CLICKED,
        buildAdditionalInfoHotelMediaGalleryClicked({
          hotelMediaType: HOTEL_MEDIA_TYPE.VIDEO,
        }),
      );
      try {
        const playPromise = this.vidRef.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              this.setState({
                videoPlaying: true,
              });
            })
            .catch(() => {});
        }
      } catch {
        // ignore error
      }
    } else {
      this.vidRef.pause();
      this.setState({
        videoPlaying: false,
      });
    }
  };

  render() {
    const { videoPlaying } = this.state;
    const { poster, src } = this.props;
    return (
      <div className={STYLES.VideoItemNode}>
        <video // eslint-disable-line jsx-a11y/media-has-caption
          className={STYLES.VideoItemNode__video}
          poster={poster}
          src={src}
          controls={videoPlaying}
          ref={(r) => {
            this.vidRef = r;
          }}
        />
        <div style={{ display: videoPlaying ? 'none' : 'block' }}>
          <PlayOverlay onClick={() => this.onClick('play')} />
        </div>
      </div>
    );
  }
}

export default withMiniEventTracker(VideoItemNode);
